import React, {Component} from 'react';
import InfoBulle from './info';

import {FormError} from './form-errors';
import {moins} from '../img/moins.png';
import {plus} from  '../img/plus.png';


export default class  Questions extends Component {
	state = {
		moin6 : 0 ,
		categories : [],
		revenu : '' ,
		childsCount :0,
		enfants : {
			"moin6" : 0,
			"6to10" : 0,
			"11to14" : 0,
			"15to18" : 0,
			"plus18" : 0,
		},
		categorieMap : {
			'6-ans':"moin6",
			'6-10-ans':"6to10",
			'11-14-ans':"11to14",
			'15-18-ans':"15to18",
			'18-ans':"plus18"
		},
		errors : [],

	}

	handleChangeNbEnfant = (e) =>{
		const newValue = parseInt(e.target.value);
		this.updateNbEnfant( this.state.categorieMap[e.target.id] , newValue)
	}

	substractNb = (e)=>{
		const  inputElement = e.target.nextElementSibling;
		const  catEnfant =  this.state.categorieMap[inputElement.id];
		const newValue = this.state.enfants[catEnfant] > 0 ? this.state.enfants[catEnfant]-1 : 0  ;
		inputElement.value = newValue;
		this.updateNbEnfant( catEnfant, newValue);
	
	}
	incrementNb = (e)=>{
		const  inputElement = e.target.previousElementSibling;
		const  catEnfant =  this.state.categorieMap[inputElement.id];
		const newValue =  this.state.enfants[catEnfant]+1  ;
		inputElement.value = newValue;
		this.updateNbEnfant( catEnfant, newValue);
	
	}

	updateNbEnfant = (categorieEnfant , newValue)=>{
		newValue =  (!isNaN(newValue)) ? newValue : 0; 
		this.setState(( {enfants} )=>{
			enfants[categorieEnfant] = newValue; 
			const childsCount = Object.keys(enfants).reduce( (sum , key) => ( sum + enfants[key]) , 0);
			return {
				enfants : enfants,
				childsCount : childsCount
			};

		});
		
	}
	handleChangeMontant = (e)=>{
		const montant = !isNaN(e.target.value) ? e.target.value : 0;

		this.setState({revenu:montant});

	}
	getLimitCharges = function (c){
	    if(c === 1){
	        return 27141;
	    }else if(c === 2){
	        return 33404;
	    }else if(c === 3){
	        return 39667;
	    }else if(c === 4){
	        return 45930;
	    }else if(c === 5){
	        return 49567;
	    }else if(c > 5){
	        return 55830;
	    }else {
	        return 0;
	    }
	}
	calculateResult = (charges)=>{
		const plafond = this.getLimitCharges(charges) ;
		return this.state.revenu < plafond ;
	}
	calculer_ars =  ()=>{

		var C = this.state.enfants[this.state.categorieMap['6-10-ans']];
        var D = this.state.enfants[this.state.categorieMap['11-14-ans']];
        var E = this.state.enfants[this.state.categorieMap['15-18-ans']];

	    var Cval  = C * 416.40;
	    var Dval  = D * 439.38;
	    var Eval = E * 454.60;

	    

	    return Cval + Dval + Eval;
	}

	nextStep= ()=>{
		var newErrors = [];
		if (this.state.revenu === '' || isNaN(this.state.revenu) ){
			newErrors.push('Le champ revenu N-2 est requis');
		}

		const typeEfants = Object.keys(this.state.enfants);
		const nbEnfants = typeEfants.reduce( (sum , elt )=> ( this.state.enfants[elt] + sum ) , 0);
		
		if (nbEnfants === 0 ){
			newErrors.push('Veuillez saisir au moins un enfant à charge');
		}
		
		this.setState({errors:newErrors});
		if (newErrors.length === 0 ){
			//send data
			const montantARS = this.calculer_ars().toFixed(2);
			const accesARS = (montantARS == 0) ? false : this.calculateResult(nbEnfants);

			this.props.setData( {"accesARS" : accesARS , "montantARS" : montantARS});
			//nextStep 
			this.props.nextStep();
		}
	}

	toogleActive = (event) => {
    	const element = event.target;
    	element.classList.toggle('active'); // Toggle the 'active' class for the clicked element
  	}

	render(){
		const infoARS =<> <p>Vous devez indiquer votre revenu imposable N-2. Ainsi, renseignez <strong>le montant 2022 pour estimer l'ARS en 2024.</strong></p>
            <p><strong><span  >Le revenu imposable</span></strong> correspond à l’ensemble des revenus perçus (salaires, revenus fonciers et mobiliers…) auquel vous retranchez vos charges réelles ou forfaitaires ainsi que vos abattements fiscaux. </p>
            <p><strong>Où le trouver ?</strong> Il apparaît sur votre avis d’imposition sous l'appellation  « Revenu imposable » en dessous de la ligne « Revenu brut global ».</p></>;
		
		return <div className="envariables">
			<div className="formcontent">
			    <div className="revenu-input">
			        <div for="revenu" className="question">
			            <span className="main-question">
			                Quel est votre <strong>revenu imposable</strong> de l'<strong>ann&eacute;e N-2</strong>?
			            </span>
			                    <InfoBulle message={infoARS} /> 
			        </div>
			        <span className="simars_label">Montant</span>
			        <input type="number" id="revenu" placeholder="0" onChange={this.handleChangeMontant} required />
			        <strong className="eurosign">€</strong>
			        <div className="clear clearfix"></div>
			    </div>
			    <div className="enfants-input">
			        <div className="question">
			            <span className="main-question">
			                Combien d'<strong>enfants &agrave; charge</strong> avez-vous?
			            </span>
			            <div className="indication-text">
			                <span>
			                    Afin de conna&icirc;tre avec pr&eacute;cision le montant de l'allocation de rentr&eacute;e scolaire, indiquez
			                    l'&acirc;ge de vos enfants au 31 d&eacute;cembre 2024
			                </span>
			            </div>
			        </div>
			        <div className="input-container">
			            <label className="as-show-btn" onClick={this.toogleActive} for="6-ans" categorie="moin6">Enfants - de 6 ans</label>
			            <div className="number" id="moin6">
			                <span>Nb d'enfants &agrave; charge</span>
			                <div className="input">
			                    <div className="minus" onClick={this.substractNb}></div>
			                    <input 
			                    	type="text"
			                    	id="6-ans"
			                    	placeholder="0"
			                    	onChange = {this.handleChangeNbEnfant}
			                     />
			                    <div className="plus" onClick={this.incrementNb}></div>
			                </div>
			            </div>
			        </div>
			        <div className="clear clearfix"></div>
			        <div className="input-container">
			            <label className="as-show-btn" onClick={this.toogleActive} for="6-10-ans" data-target="6to10">Enfants entre 6 et 10 ans</label>
			            <div className="number" id="6to10">
			                <span>Nb d'enfants &agrave; charge</span>
			                <div className="input">
			                    <div className="minus" onClick={this.substractNb}></div>
			                    <input 
			                    	type="text"
			                    	id="6-10-ans"
			                    	placeholder="0"
			                    	onChange = {this.handleChangeNbEnfant}
			                    	/>
			                    <div className="plus" onClick={this.incrementNb}></div>
			                </div>
			            </div>
			        </div>
			        <div className="clear clearfix"></div>
			        <div className="input-container">
			            <label className="as-show-btn" onClick={this.toogleActive} for="11-14-ans" data-target="11to14">Enfants entre 11 et 14 ans</label>
			            <div className="number" id="11to14">
			                <span>Nb d'enfants &agrave; charge</span>
			                <div className="input">
			                    <div className="minus" onClick={this.substractNb}></div>
			                    <input type="text" id="11-14-ans" placeholder="0" onChange = {this.handleChangeNbEnfant} />
			                    <div className="plus" onClick={this.incrementNb}></div>
			                </div>
			            </div>
			        </div>
			        <div className="clear clearfix"></div>
			        <div className="input-container">
			            <label className="as-show-btn" onClick={this.toogleActive} for="15-18-ans" data-target="15to18">Enfants entre 15 et 18 ans</label>
			            <div className="number" id="15to18">
			                <span>Nb d'enfants &agrave; charge</span>
			                <div className="input">
			                    <div className="minus" onClick={this.substractNb}></div>
			                    <input type="text" id="15-18-ans" placeholder="0" onChange = {this.handleChangeNbEnfant}/>
			                    <div className="plus" onClick={this.incrementNb}></div>
			                </div>
			            </div>
			        </div>
			        <div className="clear clearfix"></div>
			        <div className="input-container">
			            <label className="as-show-btn" onClick={this.toogleActive} for="18-ans" data-target="plus18">Enfants de plus de 18 ans</label>
			            <div className="number" id="plus18">
			                <span>Nb d'enfants &agrave; charge</span>
			                <div className="input">
			                    <div className="minus" onClick={this.substractNb}></div>
			                    <input type="text" id="18-ans" placeholder="0" onChange = {this.handleChangeNbEnfant} />
			                    <div className="plus" onClick={this.incrementNb}></div>
			                </div>
			            </div>
			        </div>
			        <div className="clear clearfix"></div>
			    </div>

			    <FormError errors = {this.state.errors}/>
			    <button id="calculars" style={{background : (this.state.childsCount === 0 || this.state.revenu ==='') ? "#01205c" : "#c10f33"}} className="disabled" onClick={this.nextStep}>Valider</button>
			</div>
		</div>;
	}
}; 